import React, { useMemo } from "react";
import PropTypes from "prop-types";
import LinkStyle, { PrimaryLinkStyled } from "./Link.styled";
import Typografy from "../Typografy";

const Link = (props) => {
  const { href, disabled, target, textSize, textStrong } = props;

  const normalTextVariant = useMemo(() => (textStrong ? "1" : "2"), [
    textStrong,
  ]);

  return (
    <Typografy
      as={LinkStyle}
      {...props}
      textType="link"
      textVariant={textSize !== "xl" ? normalTextVariant : null}
      rel={target ? "noopener noreferrer" : null}
      elementType="link"
      disabled={disabled || !href}
    />
  );
};

Link.defaultProps = {
  target: null,
  textSize: "md",
  textStrong: false,
  href: null,
  disabled: false,
};

Link.propTypes = {
  href: PropTypes.string,
  target: PropTypes.string,
  textStrong: PropTypes.bool,
  textSize: PropTypes.oneOf(["sm", "md", "lg", "xl"]),
  disabled: PropTypes.bool,
};

export const LinkPrimary = (props) => (
  <PrimaryLinkStyled {...props} as={Link} />
);

LinkPrimary.defaultProps = {
  ...Link.defaultProps,
};

LinkPrimary.propTypes = {
  ...Link.propTypes,
};

export default Link;
